import React from 'react'
import { Link } from 'react-router-dom'
const MaryWard = () => {
  return (
    <>
    <section className="page-header">
        <div className="page-header-bg"></div>
        <div className="page-header-shape-1"><img src="/Images/page-header-shape-1.png" alt="Loreto Convent School, Delhi Cantt"/></div>
        <div className="container">
        <div className="page-header__inner">
            <ul className="thm-breadcrumb list-unstyled ml-0">
                <li><Link to="/"> Home</Link></li>
                <li> Founder </li>
                <li> Mary Ward  </li>
            </ul>
            <h2>Mary Ward </h2>
        </div>
        </div>
    </section>
                <section className="innerbody">
                <div className="container">
                <div className="row">
                <div className="col-md-8">
                <p>Mary Ward was born in Yorkshire, England in 1585 at a time of severe persecution of Catholics. Despite the sufferings, loss of property and even death of dear ones, many of her friends, relatives, and acquaintances remained faithful to their religion. Brought up in such an atmosphere of heroism and self-sacrifice, Mary grew up to be a woman of deep faith, steely determination and unswerving loyalty to the Church.
                </p>
                <p>Already at the age of 15 she decided to be ‘wholly God’s’ but it was only when she reached the age of 21 that she was allowed to follow her dream of becoming a religious. In 1606 she crossed the English Channel and went over to St. Omer (Belgium) where she joined a Poor Clare’s Convent as a lay sister only to discover later that she was not to be a Poor Clare. She left the Convent; after a few more years of search and struggle she returned to England where she spent her time visiting lapsed Catholics and prisoners, helping and supporting priests and arranging for them to administer the sacraments. One day in 1609 God showed her clearly that she was to do something else ‘more to the glory of God’ the exact nature of which still remained unclear to her.
                </p>
                </div>
                <div className="col-md-4">
                <img src="/Images/mary.png" className="img-fluid mx-auto d-block"  alt="Loreto Convent School Delhi Cantt" />
                <p className="text-center">
                <span className="red">MARY WARD</span><br />
                "A WOMAN BEYOND COMPARE"<br />
                <span className="red">- Pope Pius (XII)</span></p>
                </div>
                <div className="col-md-12">
                <p>Attracted by her warm and charming personality and inspired by her heroic spirit and obvious love for the Lord, several young women of her circle of friends, relatives and acquaintances joined her. Together they went to the Continent where Mary opened a number of schools for children. Seeing the success and apostolic impact of her work, Church and Civil authorities invited her to open schools in their countries. Soon Mary began to think of establishing a religious order. But women religious of the time had to observe strict enclosure, a rule that limited their activities to little more than prayer and household chores.
                </p>
                <p>Mary Ward was directed by God through a series of mystical experiences to found an Order modelled on the pattern of the Society of Jesus. She wanted her Congregation to be directly under the Pope and be free from enclosure, the obligation of the choir and the wearing of religious habit. These were novel ideas and not acceptable to the church and Mary’s initiatives brought in a storm of protests from all sides because her attempt to begin an apostolic Order for women went against the norms and practices of the time. But Mary, realizing the great opportunities open to women religious in defending and protecting Faith, refused to bow down to the pressures. As a result she had to suffer much and was branded as a heretic and imprisoned and her Congregation suppressed. Only a faithful band remained loyal to her vision. Despite all attempts to discredit her and destroy her work, she remained firm, utterly convinced of her mission. Though later she was exonerated from all charges of heresy and given permission to live with her companions in Rome, the ban forbidding her foundation was not revoked.
                </p>
                <p>Despite the many hurdles in the way of obtaining the approbation of her Institute, Mary placed her trust in the Lord as she says, “What is not done in one year can be done in another. We must wait for God Almighty’s leisure, for we must follow, not go before Him.”
                </p>
                <p>The years of waiting and uncertainty took its toll on Mary’s health. In 1640 she returned to England where a civil war was raging. She and her companions sought refuge in Heworth, a village outside York. There she spent the last months of her life and on 30th January 1645 she breathed her last, pronouncing the name of Jesus three times.
                </p>
                <p>Mary Ward is buried in the cemetery of the Anglican Church, Osbaldwick and her grave stone is still kept inside the church which bears the following inscription:</p>
                </div>
                <div className="col-md-12">
                <img src="/Images/mary_ward_img.png" className="img-fluid mx-auto d-block"  alt="Loreto Convent School Delhi Cantt" />
                <p>
                <center>“To love the poor<br/>
                Persevere in the same,<br/>
                Live, die and rise with them<br/>
                Was all the aim of Mary Ward<br/>
                Who having lived 60 years and 8 days<br/>
                Died on 30th January 1645.”<br/>
                </center>
                </p>
                <h1 className="head1">INSITES INTO MARY WARD'S LIFE</h1>
                </div>
                </div>
                <div className="row align-images g-4">
                <div className="col-lg-4 col-md-6 col-12">
                <img src="/Images/mary_1.jpg"  className="img-fluid" alt="Loreto Convent School, Delhi Cantt"/>
                <h6>Mary Ward's Possessions</h6>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                <img src="/Images/mary_2.jpg"  className="img-fluid" alt="Loreto Convent School, Delhi Cantt"/>
                <h6> Rosary worn by Mary Ward </h6>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                <img src="/Images/mary_3.jpg"  className="img-fluid" alt="Loreto Convent School, Delhi Cantt"/>
                <h6>Anger Convent</h6>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                <img src="/Images/mary_4.jpg"  className="img-fluid" alt="Loreto Convent School, Delhi Cantt"/>
                <h6>Mary Ward as a Child</h6>
                </div>
                
                <div className="col-lg-4 col-md-6 col-12">
                <img src="/Images/mary_5.jpg"  className="img-fluid" alt="Loreto Convent School, Delhi Cantt"/>
                <h6>Lambeth
                </h6>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                <img src="/Images/mary_6.jpg"  className="img-fluid" alt="Loreto Convent School, Delhi Cantt"/>
                <h6>Mary Ward's Hat	</h6>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                <img src="/Images/mary_7.jpg"  className="img-fluid" alt="Loreto Convent School, Delhi Cantt"/>
                <h6>Mary Ward's Grave Stone	</h6>
                </div>
                
                <div className="col-lg-4 col-md-6 col-12">
                <img src="/Images/mary_8.jpg"  className="img-fluid" alt="Loreto Convent School, Delhi Cantt"/>
                <h6>Clement-Church	</h6>
                </div>
                
                <div className="col-lg-4 col-md-6 col-12">
                <img src="/Images/mary_9.jpg"  className="img-fluid" alt="Loreto Convent School, Delhi Cantt"/>
                <h6>Mary Ward's Shoes	</h6>
                </div>
                
                <div className="col-lg-4 col-md-6 col-12">
                <img src="/Images/mary_10.jpg"  className="img-fluid" alt="Loreto Convent School, Delhi Cantt"/>
                <h6>Mary Ward's House
                </h6>
                </div>
                </div>
                </div>
                </section>
   </>
  )
}

export default MaryWard